import expiredImage from '@assets/img/svg/expired.svg'
import ButtonToCampaigns from '@components/button-to-campaigns/button-to-campaigns.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import MySquid from '@hub/shared/interfaces/my-squid.interface'
import onConfigChange from '@src/observables/on-config-change.observable'
import { Subscription } from 'rxjs'
import './expired.page.scoped.scss'

const ExpiredPage = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const [height, setHeight] = useState(window.innerHeight)
  const onConfigChangeSubscription = useRef<Subscription | null>(null)
  const [config, setConfig] = useState<MySquid | null>(null)

  const { t } = useTranslation('expiredPage')

  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((config) => {
      setConfig(config)
    })
    return () => {
      onConfigChangeSubscription?.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  return (
    <main
      className="expired-page box-shadow container display-flex justify-content-center align-items-center"
      style={{ height: width < 991 ? `calc(${height}px - 52px)` : 'auto' }}
    >
      <h1 className="title-page text-center" dangerouslySetInnerHTML={{ __html: t('titleExpired') as string }} />
      <figure className="illustration">
        {config && config?._id ? (
          <img src={expiredImage} alt={`${t('titleExpired')}`} />
        ) : (
          <img src={expiredImage} alt={`${t('titleExpired')}`} />
        )}
      </figure>
      <ButtonToCampaigns className="button" />
    </main>
  )
}

export default withTransaction('Expired Page', 'page')(ExpiredPage)
